import {IUpdateHorseInconclusiveHealthIssuesBP} from 'BusinessPortal/models/horse/IInconclusiveHealthIssuesBP';
import {IHorseHealthInfoSectionData} from 'BusinessPortal/components/BusinessPortalDashboard/Horses/HorseForm/parts/HorseHealthInfoSection/models/IHorseHealthInfoSectionData';

export const convertToClient = (data: IHorseHealthInfoSectionData): IUpdateHorseInconclusiveHealthIssuesBP => {
  return {
    ...data,
    inconclusiveHealthIssues: data.horseHealthIssues?.map(i => i.id) || []
  };
};
